// ─── Business Type Config — Single Source of Truth ───────────────────────────
// Defines: labels, kanban columns, form type, and default categories per type.

export const BUSINESS_TYPES = {
  laundry: {
    label: 'Laundry & Jasa Cuci',
    emoji: '🧺',
    description: 'Laundry kiloan, cuci sepatu, helm, karpet, boneka, dan sejenisnya.',
    formType: 'laundry',
    kanbanColumns: [
      { id: 'masuk',        label: { id: 'Masuk',        en: 'Received'   }, color: 'blue'    },
      { id: 'proses_cuci',  label: { id: 'Diproses',     en: 'Processing' }, color: 'yellow'  },
      { id: 'siap_diambil', label: { id: 'Siap Diambil', en: 'Ready'      }, color: 'emerald' },
      { id: 'selesai',      label: { id: 'Selesai',      en: 'Done'       }, color: 'slate'   },
    ],
    defaultCategories: [
      'Laundry Kiloan', 'Laundry Satuan (Dry Clean)', 'Laundry Selimut & Bed Cover',
      'Laundry Karpet', 'Cuci Sepatu', 'Cuci Helm', 'Cuci Tas',
      'Cuci Mobil', 'Cuci Motor', 'Cuci Sofa & Kasur', 'Cuci Gorden',
      'Cuci Boneka', 'Laundry Lainnya',
    ],
  },
  rental: {
    label: 'Rental & Sewa Aset',
    emoji: '🚗',
    description: 'Rental kendaraan, kamera, lapangan olahraga, studio, dan aset lainnya.',
    formType: 'rental',
    kanbanColumns: [
      { id: 'masuk',        label: { id: 'Masuk',          en: 'Received'   }, color: 'blue'   },
      { id: 'serah_terima', label: { id: 'Serah Terima',   en: 'Handover'   }, color: 'purple' },
      { id: 'sedang_disewa',label: { id: 'Sedang Disewa',  en: 'In Use'     }, color: 'yellow' },
      { id: 'selesai',      label: { id: 'Selesai',        en: 'Done'       }, color: 'slate'  },
    ],
    defaultCategories: [
      'Rental Mobil', 'Rental Motor', 'Rental Sepeda',
      'Rental iPhone / HP', 'Rental Kamera', 'Rental PS (PlayStation)', 'Rental Laptop',
      'Rental Baju / Kebaya / Jas', 'Rental Alat Pesta / Dekorasi', 'Rental Sound System',
      'Rental Studio Foto/Musik', 'Sewa Lapangan Futsal', 'Sewa Lapangan Badminton',
      'Sewa Lapangan Padel', 'Sewa Lapangan Mini Soccer', 'Sewa Lapangan Basket',
      'Sewa Ruko/Kios', 'Rental Lainnya',
    ],
  },
  servis_elektronik: {
    label: 'Servis Elektronik',
    emoji: '🔧',
    description: 'Servis HP, laptop, AC, TV, kamera, printer, dan elektronik rumah tangga.',
    formType: 'servis',
    kanbanColumns: [
      { id: 'masuk',             label: { id: 'Masuk',            en: 'Received'   }, color: 'blue'   },
      { id: 'diagnosa',          label: { id: 'Diagnosa',         en: 'Diagnosis'  }, color: 'orange' },
      { id: 'sedang_dikerjakan', label: { id: 'Sedang Dikerjakan',en: 'In Progress'}, color: 'yellow' },
      { id: 'selesai',           label: { id: 'Selesai',          en: 'Done'       }, color: 'slate'  },
    ],
    defaultCategories: [
      'Servis AC', 'Servis PC & Laptop', 'Servis Jam (Arloji)',
      'Servis TV & Elektronik Rumah Tangga', 'Servis HP', 'Servis Kamera',
      'Servis Printer', 'Servis Speaker & Audio', 'Servis Lainnya',
    ],
  },
  servis_kendaraan: {
    label: 'Servis Kendaraan & Bengkel',
    emoji: '🏍️',
    description: 'Bengkel motor, mobil, tambal ban, cuci kendaraan, dan detailing.',
    formType: 'servis',
    kanbanColumns: [
      { id: 'masuk',             label: { id: 'Masuk',            en: 'Received'   }, color: 'blue'   },
      { id: 'diagnosa',          label: { id: 'Diagnosa',         en: 'Diagnosis'  }, color: 'orange' },
      { id: 'sedang_dikerjakan', label: { id: 'Sedang Dikerjakan',en: 'In Progress'}, color: 'yellow' },
      { id: 'selesai',           label: { id: 'Selesai',          en: 'Done'       }, color: 'slate'  },
    ],
    defaultCategories: [
      'Bengkel Motor', 'Bengkel Mobil', 'Bengkel Sepeda',
      'Servis Ban (Tambal Ban/Ganti Ban)', 'Cuci & Salon Kendaraan (Detailing)',
      'Bengkel Las', 'Bengkel Aksesoris Kendaraan', 'Bengkel Lainnya',
    ],
  },
  mua: {
    label: 'MUA & Janji Temu Studio',
    emoji: '💄',
    description: 'Make up artist, wedding organizer, salon, barbershop, spa, dan studio.',
    formType: 'appointment',
    kanbanColumns: [
      { id: 'masuk',             label: { id: 'Masuk',           en: 'Received'   }, color: 'blue'   },
      { id: 'konfirmasi',        label: { id: 'Dikonfirmasi',    en: 'Confirmed'  }, color: 'purple' },
      { id: 'sedang_dikerjakan', label: { id: 'Sedang Dilayani', en: 'In Service' }, color: 'yellow' },
      { id: 'selesai',           label: { id: 'Selesai',         en: 'Done'       }, color: 'slate'  },
    ],
    defaultCategories: [
      'Jasa MUA (Make Up Artist)', 'Wedding Organizer', 'Jasa Foto/Videografi (Prewedding, Event)',
      'Jasa Dekorasi', 'Salon & Perawatan Kecantikan', 'Barbershop', 'Spa & Pijat', 'Lainnya',
    ],
  },
  penjahit: {
    label: 'Penjahit & Permak',
    emoji: '✂️',
    description: 'Permak baju, jahit custom, bordir, sablon, dan permak tas/sepatu.',
    formType: 'appointment',
    kanbanColumns: [
      { id: 'masuk',             label: { id: 'Masuk',           en: 'Received'   }, color: 'blue'   },
      { id: 'konfirmasi',        label: { id: 'Dikonfirmasi',    en: 'Confirmed'  }, color: 'purple' },
      { id: 'sedang_dikerjakan', label: { id: 'Sedang Dikerjakan',en:'In Progress'}, color: 'yellow' },
      { id: 'selesai',           label: { id: 'Selesai',         en: 'Done'       }, color: 'slate'  },
    ],
    defaultCategories: [
      'Permak Baju / Jas / Seragam', 'Permak Celana', 'Jahit Baju Custom',
      'Permak Sepatu / Tas', 'Bordir & Sablon', 'Permak Gorden', 'Permak Lainnya',
    ],
  },
  lainnya: {
    label: 'Usaha Jasa Lain',
    emoji: '✨',
    description: 'Untuk usaha jasa di luar kategori yang tersedia.',
    formType: 'generic',
    kanbanColumns: [
      { id: 'masuk', label: { id: 'Masuk', en: 'Received' }, color: 'blue' },
      { id: 'proses_cuci', label: { id: 'Diproses', en: 'Processing' }, color: 'yellow' },
      { id: 'siap_diambil', label: { id: 'Siap Diambil', en: 'Ready' }, color: 'emerald' },
      { id: 'selesai', label: { id: 'Selesai', en: 'Done' }, color: 'slate' },
    ],
    defaultCategories: ['Layanan Umum'],
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────

/** Get business type config, fallback to laundry */
export function getBTConfig(businessType) {
  return BUSINESS_TYPES[businessType] || BUSINESS_TYPES.lainnya;
}

/** Get kanban columns for a given business type */
export function getKanbanColumns(businessType) {
  return getBTConfig(businessType).kanbanColumns;
}

/** Get form type for a given business type */
export function getFormType(businessType) {
  return getBTConfig(businessType).formType;
}

/** All column IDs across all types — used to build STATUS_CONFIG dynamically */
export const ALL_STATUS_COLORS = {
  blue:    { bg: 'bg-blue-100',   text: 'text-blue-700',   border: 'border-blue-400',   dot: 'bg-blue-500'   },
  yellow:  { bg: 'bg-yellow-100', text: 'text-yellow-700', border: 'border-yellow-400', dot: 'bg-yellow-500' },
  emerald: { bg: 'bg-emerald-100',text: 'text-emerald-700',border: 'border-emerald-400',dot: 'bg-emerald-500'},
  purple:  { bg: 'bg-purple-100', text: 'text-purple-700', border: 'border-purple-400', dot: 'bg-purple-500' },
  orange:  { bg: 'bg-orange-100', text: 'text-orange-700', border: 'border-orange-400', dot: 'bg-orange-500' },
  slate:   { bg: 'bg-slate-100',  text: 'text-slate-600',  border: 'border-slate-300',  dot: 'bg-slate-400'  },
};

/** Build a flat STATUS_CONFIG map from all business types (for StatusBadge) */
export function buildStatusConfig() {
  const config = {};
  Object.values(BUSINESS_TYPES).forEach(bt => {
    bt.kanbanColumns.forEach(col => {
      if (!config[col.id]) {
        config[col.id] = {
          ...ALL_STATUS_COLORS[col.color],
          label: col.label,
        };
      }
    });
  });
  return config;
}
